/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Cabin of class to be used for the specified passengers.
 * Higher classes account for more emissions since total weight and volume necessary to accomodate the class is higher.
 * This parameter defaults to first.
 */
export var CabinClass;
(function (CabinClass) {
    CabinClass["ECONOMY"] = "economy";
    CabinClass["BUSINESS"] = "business";
    CabinClass["FIRST"] = "first";
})(CabinClass || (CabinClass = {}));
//# sourceMappingURL=CabinClass.js.map